export const APPLICATION_GRADE_OPTIONS = [
  "Nursery",
  "Kindergarten",
  "Pre-1A",
  "Grade 1",
  "Grade 2",
  "Grade 3",
  "Grade 4",
  "Grade 5",
  "Grade 6",
  "Grade 7",
  "Grade 8",
] as const;

export const CURRENT_GRADE_OPTIONS = [
  { label: "Select...", value: "" },
  { label: "Home", value: "Home" },
  { label: "Playgroup", value: "Playgroup" },
  { label: "Not currently enrolled", value: "Not currently enrolled" },
  ...APPLICATION_GRADE_OPTIONS.map((grade) => ({ label: grade, value: grade })),
] as const;

export const getDefaultAdmissionsCalendarDate = (
  now: Date = new Date(),
): Date => new Date(now.getFullYear(), now.getMonth(), 1);

export const isSameAdmissionsCalendarMonth = (
  left: Date,
  right: Date,
): boolean =>
  left.getFullYear() === right.getFullYear() &&
  left.getMonth() === right.getMonth();

const startOfLocalDay = (date: Date): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const isAdmissionsScheduleDateInPast = (
  calendarDate: Date,
  day: number,
  now: Date = new Date(),
): boolean => {
  const candidate = new Date(
    calendarDate.getFullYear(),
    calendarDate.getMonth(),
    day,
  );
  if (Number.isNaN(candidate.getTime())) return true;
  return startOfLocalDay(candidate).getTime() < startOfLocalDay(now).getTime();
};

export const isSelectableAdmissionsScheduleDate = (
  calendarDate: Date,
  day: number,
  now: Date = new Date(),
): boolean => {
  if (isAdmissionsScheduleDateInPast(calendarDate, day, now)) return false;
  const candidate = new Date(
    calendarDate.getFullYear(),
    calendarDate.getMonth(),
    day,
  );
  const dayOfWeek = candidate.getDay();
  return dayOfWeek !== 0 && dayOfWeek !== 6;
};

export const navigateAdmissionsCalendarMonth = (
  currentCalendarDate: Date,
  direction: number,
  now: Date = new Date(),
): Date => {
  const minimumMonth = getDefaultAdmissionsCalendarDate(now);
  const nextMonth = new Date(
    currentCalendarDate.getFullYear(),
    currentCalendarDate.getMonth() + direction,
    1,
  );
  if (nextMonth.getTime() < minimumMonth.getTime()) {
    return minimumMonth;
  }
  return nextMonth;
};
